import { xhrRequest, afterXhrRequest, formSerializer } from '../../../../shared/helpers'

export const inviteeDetails = invitation => `${invitation.first_name || ''} ${invitation.last_name || ''} <${invitation.email}>`

export const dateTimeDisplay = (dateTime, dateOnly=false) => moment(dateTime).format(`MMMM Do YYYY${dateOnly ? '' : ', h:mm a'}`)

export const submitUserInvitationForm = ({ event, submitUrl, onSuccess, onError }) => {
  event.preventDefault()
  const userInvitation = formSerializer(event.target)
  const userInvitationParams = {
    ...userInvitation,
    project_ids: userInvitation.project_ids ? userInvitation.project_ids.split(',') : []
  }
  xhrRequest(submitUrl, 'post', { user_invitation: userInvitationParams }).then(res => {
    onSuccess(res.data)
    afterXhrRequest(res)
  }).catch((error, res) => {
    onError(error.response.data.errors)
    afterXhrRequest(error.response)
  })
}

export const resendInvitation = (event, url, id, successHandler) => {
  event.preventDefault()
  const requestUrl = `${url}/${id}`
  xhrRequest(requestUrl, 'put', {}).then(res => {
    successHandler(res.data)
    afterXhrRequest(res)
  })
}

export const deleteInvitation = (event, url, id, successHandler) => {
  event.preventDefault()
  if (confirm('Are you sure?')) {
    const requestUrl = `${url}/${id}`
    xhrRequest(requestUrl, 'delete', {}).then(res => {
      successHandler(res.data)
      afterXhrRequest(res)
    }).catch(err => {
      afterXhrRequest(err.response)
    })
  }
}



// WEBPACK FOOTER //
// ./app/javascript/reactFeatures/company-users/components/user-invitations/userInvitationsHelpers.js